var MDA_HANDOUT, MdaHandoutsView, MdaTopicsActions, MiniDSList, MiniDSToolbar, QuestionsListComponentActions, ReactComponent, ReactToolbarView, ReferencesActions, View, alt, mediator,
  __hasProp = {}.hasOwnProperty,
  __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

alt = require('alt');

MdaTopicsActions = require('actions/mda_topics_actions');

MiniDSList = require('components/mini_ds/list');

MiniDSToolbar = require('components/mini_ds/toolbar');

MDA_HANDOUT = require('lib/db_docs/doc_types').MDA_HANDOUT;

ReferencesActions = require('actions/references_actions');

QuestionsListComponentActions = require('actions/questions_list_component_actions');

mediator = require('mediator');

ReactComponent = require('base/lib/traits/react_component');

ReactToolbarView = require('views/react_toolbar_view');

View = require('base/views/view');

module.exports = MdaHandoutsView = (function(_super) {
  __extends(MdaHandoutsView, _super);

  function MdaHandoutsView() {
    return MdaHandoutsView.__super__.constructor.apply(this, arguments);
  }

  MdaHandoutsView.prototype.container = '#page-container';

  MdaHandoutsView.prototype.autoRender = true;

  MdaHandoutsView.prototype.initialize = function() {
    MdaHandoutsView.__super__.initialize.call(this);
    this.subview('toolbar', new ReactToolbarView({
      component: MiniDSToolbar,
      props: {
        documentType: MDA_HANDOUT
      }
    }));
    return this.enable(ReactComponent);
  };

  MdaHandoutsView.prototype.afterRender = function() {
    var projectId;
    MdaHandoutsView.__super__.afterRender.call(this);
    projectId = mediator.project.id;
    ReferencesActions.fetch();
    MdaTopicsActions.fetchTopics(projectId);
    return this.renderComponent(MiniDSList, QuestionsListComponentActions, null, {
      props: {
        projectId: mediator.project.id,
        documentType: MDA_HANDOUT
      },
      fetchAndListen: {
        dbId: projectId
      },
      fetchParams: {
        questionsCollectionType: MDA_HANDOUT,
        questionType: MDA_HANDOUT
      }
    });
  };

  MdaHandoutsView.prototype.dispose = function() {
    if (this.disposed) {
      return;
    }
    this.unmountComponent();
    alt.recycle('MiniDSStore', 'QuestionsStore', 'QuestionGroupsStore', 'MembersStore', 'QuestionsListComponentStore', 'QuestionsStatusesStore', 'OrganizationsStore', 'OverarchingQuestionsStore', 'QuestionGroupsStore');
    mediator.dialogs.destroyAll('type', 'undo');
    return MdaHandoutsView.__super__.dispose.call(this);
  };

  return MdaHandoutsView;

})(View);
